module.exports = __webpack_public_path__ + "img/0-sm.535f0381.jpg";